var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-12 gap-x-4 gap-y-1 p-4 items-end"},[_c('div',{staticClass:"col-span-9 text-right font-bold"},[_vm._v("Total")]),_c('div',{staticClass:"col-span-2 text-right font-bold"},[_vm._v(_vm._s(_vm.totalAmount)+" €")])])
}
var staticRenderFns = []

export { render, staticRenderFns }